module.exports = __webpack_public_path__ + "static/media/hkd-1000.46cd8a2c.png";